import {
  HStack,
  Show,
  Spinner,
  VStack,
} from "@chakra-ui/react";
import React, { useCallback, useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth, useFake } from "../../../hooks";
import {
  ROUTE_BENEFICIARY_FILE,
  ROUTE_DASHBOARD,
  ROUTE_LOGIN,
} from "../../../navigation/routes";
import Navbar from "../../../navigation/Navbar";
import SidebarCard from "../../sidebar/SidebarCard";

const AppLayout = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { setJoinCallback, setLeaveCallback } = useFake();

  const joinCallback = useCallback(
    (assistance) => {
      navigate(ROUTE_BENEFICIARY_FILE(assistance?.assistance_request_id));
    },
    [navigate],
  );

  const leaveCallback = useCallback(
    (assistance) => {
      navigate(ROUTE_DASHBOARD);
    },
    [navigate]
  );

  useEffect(() => {
    setJoinCallback(() => joinCallback);
  }, [joinCallback, setJoinCallback]);

  useEffect(() => {
    setLeaveCallback(() => leaveCallback);
  }, [leaveCallback, setLeaveCallback]);

  if (auth.loading) {
    return <Spinner />;
  }

  if (!auth.user) {
    return <Navigate to={ROUTE_LOGIN} />;
  }

  return (
    <VStack alignItems={"stretch"} gap={0} minHeight={"100vh"}>
      <Navbar />
      <HStack alignItems={"stretch"} flexGrow={1} gap={"16px"} margin={"16px"}>
        <Show above={"md"}>
          <SidebarCard />
        </Show>
        <Outlet />
      </HStack>
    </VStack>
  );
};

export default React.memo(AppLayout);
